<ng-template #titleElement>
  <ng-content select="[sd-tab-title]" />
</ng-template>
<ng-template #bodyElement>
  <ng-content select="[sd-tab-pane]" />
</ng-template>
